<!-- -->
<template>
  <div class="detail_wrap">
    <div style="display: flex;justify-content: space-between">
      <div class="left_img_wrap">
        <h2>{{ ccMaxDetail.title }}</h2>
        <div class="images_list">
          <img :src="item" alt="" v-for="item in ccMaxDetail.images">
        </div>
      </div>
      <div class="right_info_wrap">
        <div class="buy_btn" v-if="ccMaxDetail.sale_type === '1'&&!ccMaxDetail.is_pay" @click="handleClickBuy">立即购买
        </div>
        <div class="download_btn" @click="handleClickDownload" v-else>立即下载</div>
        <div class="buy_price" v-if="ccMaxDetail.sale_type==='1'">
          <span>购买价格：</span>
          <span class="price_number">￥{{ ccMaxDetail.price }}</span>
        </div>
        <div class="res_intro">
          <span style="color: #333333">资源介绍：</span>
          <span v-text="ccMaxDetail.describe"></span>
        </div>
        <ul class="copyright_info">
          <li>版权所有：原创作者</li>
          <li>授权方式：用户购买使用权</li>
          <li>购买须知：工程资源需使用ccMAX 2.1.12及更高版本。若无法使用请升级 ccMAX软件。</li>
        </ul>
      </div>
    </div>
    <div id="buyForm" v-html="buyFormHtml"></div>
  </div>
</template>
<script>
export default {
  name: "CCMaxDetail",
  data() {
    return {
      ccMaxDetail: {
        id: '',
        sale_type: '',
        price: '',
        images: [],
        title: '',
        file_path: '',
        file_name: '',
        is_pay: false,
        describe:''
      },
      buyFormHtml: '',
    }
  },
  created() {
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.$store.dispatch("post", {
        url: "ccmax_detail",
        data: {
          id: this.$route.query.id
        }
      }).then(res => {
        if (res.status === 0) {
          const {data} = res;
          this.ccMaxDetail.id = data.id;
          this.ccMaxDetail.title = data.title;
          this.ccMaxDetail.sale_type = data.sale_type;
          this.ccMaxDetail.price = data.price;
          this.ccMaxDetail.describe = data.describe;
          this.ccMaxDetail.file_path = data.file_path;
          this.ccMaxDetail.file_name = data.file_name;
          this.ccMaxDetail.is_pay = data.is_pay;
          let json = data.images;
          const d = document.createElement('div');
          d.innerHTML = json;
          json = d.innerText || d.textContent;
          json = JSON.parse(json);
          this.ccMaxDetail.images = json;
        } else {
          this.$message.error(res.msg)
        }
      });
    },

    handleClickDownload() {
      if (this.isLogin()) {
        const data = {
          id: this.ccMaxDetail.id,
        }
        this.$store.dispatch('post', {
          url: 'ccmax_download',
          data,
        }).then(res => {
          this.getOSSData(this.ccMaxDetail.file_path, this.ccMaxDetail.file_name)
        })
      } else {
        this.$store.commit("changeQrcode", true);
      }
    },

    getOSSData(filePath, fileName) {
      var url  = `${filePath}?response-content-disposition=attachment%3B%20filename%3D${fileName}`
      window.location.href=url
      // let data = {
      //   filePath: filePath
      // }
      // $.post('https://www.enlightv.com/admin/public/oss_download', data, function (res) {
      //   if (res.status == 0) {
      //     let ossObj = new OSS({
      //       region: res.data.endpoint.split('.')[0],
      //       accessKeyId: res.data.accessKeyId,
      //       accessKeySecret: res.data.accessKeySecret,
      //       bucket: res.data.bucket,
      //     })
      //     const localFile = fileName; // filename为自定义下载后的文件名。
      //     const response = {
      //       'content-disposition': `attachment; filename=${encodeURIComponent(localFile)}`
      //     };
      //     const url = ossObj.signatureUrl(res.data.object, {response});
      //     const url2 = url.split('com')[1]
      //     const path = 'https://download.hecoos.com' + url2
      //     window.open(path)
      //   }
      // }, 'json')
    },

    handleClickBuy() {
      if (!this.isLogin()) {
        this.$store.commit("changeQrcode", true);
      } else {
        let data = {
          id: this.ccMaxDetail.id,
          uid: JSON.parse(localStorage.userInfo).id,
          source_token: JSON.parse(localStorage.userInfo).source_token,
        };
        this.$store.dispatch("post", {url: "ccmax_pay", data: data}).then(res => {
          if (res.status == 0) {
            this.buyFormHtml = res.data.buyFormHtml;
            this.$nextTick(() => {
              document.forms["alipaysubmit"].submit();
            });
          }
        });
      }
    },
  },
  watch: {
    $route() {
      if (this.$route.query.id) {
        this.getDetail()
      }
    },
  },
}
</script>
<style lang="less" scoped>
.detail_wrap {
  width: 1300px;
  margin: 30px auto;
}

.left_img_wrap {
  width: 860px;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 35px 56px;

  .images_list {
    width: 100%;

    img {
      max-width: 100%;
      margin-bottom: 20px;
    }
  }

  h2 {
    font-size: 24px;
    color: #333333;
    margin-bottom: 25px;
  }
}

.right_info_wrap {
  width: 400px;
  height: fit-content;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Source Han Sans CN;

  .buy_btn, .download_btn {
    font-size: 28px;
    font-weight: bold;
    color: #ffffff;
    line-height: 60px;
    width: 260px;
    border-radius: 30px;
    cursor: pointer;
    text-align: center;
  }

  .buy_btn {
    background: #f8a11f;
  }

  .download_btn {
    background: #1f86f8;
  }

  .buy_price {
    width: 100%;
    height: 50px;
    background: #f3f4f7;
    border-radius: 10px;
    margin: 12px 0;
    font-size: 20px;
    color: #666666;
    line-height: 50px;
    padding: 0 20px;

    .price_number {
      color: #FF3434;
      font-size: 21px;
    }
  }

  .res_intro {
    width: 100%;
    background: #f3f4f7;
    border-radius: 10px;
    margin-top: 5px;
    box-sizing: border-box;
    padding: 18px 19px;
    font-size: 16px;
    line-height: 32px;
    color: #707070;
    opacity: 1;
  }

  .copyright_info {
    font-size: 12px;
    width: 300px;
    margin: 19px auto 0;
    line-height: 20px;
    color: #9E9E9E;
  }
}
</style>
